import {Component, OnInit, Input, EventEmitter, Output, ViewChild, HostListener, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import moment from 'moment-timezone';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import {ConstantsService} from "../../services/constants/constants.service";
import * as Cookies from "js-cookie";

/****************************************************
  This component is DEPRECATED, use filter-v3 instead.
  ***************************************************/
@Component({
  selector: 'app-filter-v2',
  templateUrl: './filter-v2.component.pug',
  styleUrls: ['./filter-v2.component.scss'],
  standalone: false
})
export class FilterV2Component implements OnInit, OnChanges {
  @Input() disabled: boolean = false;
  @Input() isRadioFilters = false;
  @Input() isCheckboxFilters = false;
  @Input() isStatusFilters = false;
  @Input() isDates = false;
  @Input() radioFilter = 'all';
  @Input() locationInput = '';
  @Input() distanceInput = '';
  @Input() targetStatusInput = '';
  @Input() optedInAsInput = '';
  @Input() dateInput = '';
  @Input() rehireStatusFilters: any[] = [];
  @Input() dateFilters = {};
  @Input() filterByOptions = [{'key': 'Requested date', 'value': $localize`Requested date`}, {'key': 'Employment end date', 'value': $localize`Employment end date`}];
  @Input() filterByDefaults: any;
  @Input() start!: any;
  @Input() end!: any;
  @Input() filterBy = '';
  @Input() filterByVar;
  @Input() filter = 'All';
  @Input() filterRadioTitle = '';
  @Input() filterRadioOptions: any[] = [];
  @Input() filterCheckboxTitle = '';
  @Input() filterCheckboxOptions: any[] = [];
  @Input() filterStatusTitle = '';
  @Input() filterStatusOptions: any[] = [];
  @Input() optedInOptions: any[] = [];
  @Input() localStorageName = '';
  @Input() filterData: any = {};
  @Input() selectedTab;
  @Input() tabRedirected: boolean = false;
  @Input() filterToggleGroups: Array<{
    title: string;
    key: string;
    options: Array<{ label: string; value: string }>;
  }> = [];
  @Output() filterUpdate = new EventEmitter();
  @Output() resetFilters = new EventEmitter();
  @ViewChild('dateFilter', {static: false}) filterDropdown: any;
  languageLocale : string = Cookies.get(ConstantsService.XREF_LOCALE)?.toLocaleLowerCase() || '';
  textValueLocation = '';
  distanceDropdownOptions: any;
  selectedCheckboxFilters = {};
  selectedStatusFilters = {};
  selectedOptedInFilters = {};
  startStr = '';
  endStr = '';
  filterEnabled = false;
  filterCount = 0;
  departmentId = 'all';
  departmentCategoryId = 'all';
  peopleTab = false;
  isDepartmentFilterOn = false;
  selectedDistance='';
  selectedDate: any;
  showStartCalendar = false;
  showEndCalendar = false;
  filtersHaveBeenModified = false;
  defaultFiltersSnapshot: any = {};
  today: Date = new Date();
  config = {showWeekNumbers: false };
  dateDropdownOptions = [
    {type: 'option', value: $localize`Custom`},
    {type: 'option', value: $localize`All`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Days`},
    {type: 'option', value: $localize`Last 7 days`},
    {type: 'option', value: $localize`Last 30 days`},
    {type: 'option', value: $localize`Last 60 days`},
    {type: 'option', value: $localize`Last 90 days`},
    {type: 'option', value: $localize`Last 365 days`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar weeks`},
    {type: 'option', value: $localize`Current week`},
    {type: 'option', value: $localize`Last week`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar months`},
    {type: 'option', value: $localize`Current month`},
    {type: 'option', value: $localize`Last month`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar quarters`},
    {type: 'option', value: $localize`Current quarter`},
    {type: 'option', value: $localize`Last quarter`},
    {type: 'separator'},
    {type: 'heading', label: $localize`Calendar years`},
    {type: 'option', value: $localize`Current year`},
    {type: 'option', value: $localize`Last year`},
  ];
  showDatesRow = false;
  fromDateLabel = 'From';
  toDateLabel = 'To';
  @HostListener('document:click', ['$event'])
  clickout(event){
    let insideClick = this.eRef.nativeElement.contains(event.target) ||
      (event.path && event.path[0].id == 'date-filter-option') ||
      (event.path && event.path[0].id == 'dept-category-filter-option') ||
      (event?.target?.className == 'is-highlighted ng-star-inserted') ||
      (this.selectedTab == 'talent_pool' &&
        (event?.target?.localName === 'ngb-highlight' || event?.target?.className === 'ngb-highlight' ||
          event?.target?.className === 'dropdown-item active'));
    if(!insideClick) {
      this.filterDropdown.hide();
    }
  }

  constructor(
    private eRef: ElementRef,
    private permissions: PermissionsService
  ) { }

  // Save all filter state to localStorage/sessionStorage
  saveTalentPoolFilters() {
    const state = {
      selectedStatusFilters: this.selectedStatusFilters,
      selectedOptedInFilters: this.selectedOptedInFilters,
      textValueLocation: this.textValueLocation,
      selectedDistance: this.selectedDistance,
      selectedDate: this.selectedDate,
      start: this.start ? this.start : moment().startOf('day').subtract(30, 'days'),
      end: this.end ? this.end : moment(),
      showDatesRow: this.showDatesRow,
      filter: this.filter,
      filterEnabled: this.filterEnabled,
      filterCount: 0
    };
    let filterCount = 0;

    // Check location filter
    const isLocationSet = this.textValueLocation !== '' && this.textValueLocation !== undefined;
    if (isLocationSet) {
      filterCount += 1;
    }

    // Check status filters - count as active if non-default values are selected
    const hasNoTarget = this.selectedStatusFilters['No target'];
    const hasUnknown = this.selectedStatusFilters['Unknown'];
    const hasPotentialTarget = this.selectedStatusFilters['Potential target'];
    const hasTarget = this.selectedStatusFilters['Target'];

    // Don't count as filtered if both Potential target and Target are selected (default state)
    const isBothTargetTypesSelected = hasPotentialTarget && hasTarget;

    const isStatusFiltersNonDefault = (hasNoTarget || hasUnknown) ||
      (hasPotentialTarget || hasTarget) && !isBothTargetTypesSelected;

    if (isStatusFiltersNonDefault) {
      filterCount += 1;
    }

    // Check date filter - count as active if not default "Last 30 days"
    const isDateFilterNonDefault = this.filter !== $localize`Last 30 days`;
    if (isDateFilterNonDefault) {
      filterCount += 1;
    }

    const isOptedInFiltersNonDefault = this.selectedOptedInFilters['Candidate'] ||
      this.selectedOptedInFilters['Potential candidate'] ||
      this.selectedOptedInFilters['Ex-employee'];

    if (isOptedInFiltersNonDefault) {
      filterCount += 1;
    }
    state.filterCount = filterCount;
    localStorage.setItem('talent-pool-filters', JSON.stringify(state));
  }

  // Restore all filter state from localStorage
  restoreTalentPoolFilters() {
    const stateStr = localStorage.getItem('talent-pool-filters');
    if (stateStr) {
      const state = JSON.parse(stateStr);
      this.selectedStatusFilters = state.selectedStatusFilters || {};
      this.selectedOptedInFilters = state.selectedOptedInFilters || {};
      this.textValueLocation = state.textValueLocation || '';
      this.selectedDistance = state.selectedDistance || (this.distanceDropdownOptions ? this.distanceDropdownOptions[0].value : '');
      this.selectedDate = state.selectedDate || (this.dateDropdownOptions ? this.dateDropdownOptions[5].value : '');
      this.start = state.start ? moment(state.start) : this.start;
      this.end = state.end ? moment(state.end) : this.end;
      this.showDatesRow = !!state.showDatesRow;
      this.filter = state.filter || this.filter;
      this.filterEnabled = !!state.filterEnabled;
      this.filterCount = state.filterCount || 0;
    }
  }

  ngOnInit(): void {
    // polyfill to allow clickout above to work https://chromestatus.com/feature/5726124632965120
    if (!Event.prototype.hasOwnProperty('path')) {
      Object.defineProperty(Event.prototype, 'path', {
        get() { return this.composedPath(); }
      });
    }
    if (!this.filterBy){
      this.filterBy = this.filterByOptions[0]['key'];
    }
    if (this.selectedTab == 'talent_pool')
    {
      this.config['dateInputFormat'] = moment.localeData().longDateFormat('L');
      this.selectedStatusFilters = {
        'Target': true,
        'Potential target': true
      };
      this.selectedOptedInFilters = {
        'Candidate': false,
        'Potential candidate': false,
        'Ex-employee': false
      }
      this.filter = this.dateDropdownOptions[5]?.value || $localize`Last 30 days`;
      this.defaultFiltersSnapshot = this.getCurrentFilterSnapshot();
    }

    if( this.start && this.end){
      this.setLabel();
    }
    if (this.filterData) {
      if (Object.keys(this.filterData).length > 0) {
        this.presetFilterData();
        this.filterEnabled = true;
      }
    }
    if(this.localStorageName==='people-filters'){
      this.peopleTab = true;
    }

    if (this.selectedTab === 'talent_pool' && sessionStorage.getItem('talentPoolProfileNav') === 'true') {
      this.restoreTalentPoolFilters();
      sessionStorage.removeItem('talentPoolProfileNav');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Session flag to prevent filter reset when returning from profile page
    const preventReset = this.selectedTab === 'talent_pool' &&
      sessionStorage.getItem('talentPoolProfileNav') === 'true';

    if (changes.filterData && this.filterData) {
      if (Object.keys(changes.filterData).length > 0) {
        this.presetFilterData();
        this.filterEnabled = true;
      }
    }

    if('selectedTab' in changes){
      if(this.tabRedirected){
        // applying redirected date filter count 1
        this.filterCount = 1;
        this.filterEnabled = true;
      }
      // Only reset if not returning from profile page with FF enabled
      if (changes.selectedTab.currentValue != changes.selectedTab.previousValue && ((!this.tabRedirected)) && !preventReset) {
        this.filter = 'All';
        this.filterBy = '';
        this.reset('resetAll');
        this.filterCount = 0;
        this.resetFilters.emit('resetAll')
        localStorage.removeItem('talent-pool-filters');
        sessionStorage.removeItem('talentPoolProfileNav');
      }
    }

    if(this.peopleTab){
      this.departmentId = this.filterData['department_id'];
      this.departmentCategoryId = this.filterData['department_category_id'];
    }
    if (changes.selectedTab?.firstChange) {
      const isUSLocale = this.languageLocale === 'en-us' || this.languageLocale === 'es-us';
      const unit = isUSLocale ? $localize`:@@miles:mi` : $localize`:@@kilometers:km`;
      const values = isUSLocale ? ConstantsService.DISTANCE_VALUES_MILES : ConstantsService.DISTANCE_VALUES_KMS;
      this.distanceDropdownOptions = values.map(val => ({
        key: `${val} ${unit}`,
        value: `${val} ${unit}`
      }));
      this.selectedDistance = this.distanceDropdownOptions[0].value;
      this.selectedDate = this.dateDropdownOptions[5].value;
    }
  }

  presetFilterData() {
    if (this.isCheckboxFilters && Array.isArray(this.filterData?.checkboxOption)) {
      this.filterData.checkboxOption.forEach(f => {
        if (f !== 'all') {
          this.selectedCheckboxFilters[f] = true;
        }
      });
    }
    if (this.isStatusFilters && Array.isArray(this.filterData?.statusOption)) {
      this.filterData.statusOption.forEach(f => {
        this.selectedStatusFilters[f] = true;
      });
    }
    if (this.filterData?.filter && this.filterData.filter !== 'All') {
      this.filter = this.filterData.filter;
      this.filterBy = this.filterData.filterBy;
      this.start = moment(this.filterData.start_date);
      this.end = moment(this.filterData.end_date);
    }

    this.departmentId = (this.filterData.deparmentId !== 'all') ? this.filterData.deparmentId : 'all';
    this.departmentCategoryId = (this.filterData.department_category_id !== 'all') ? this.filterData.department_category_id : 'all'

    let statusFiltersActive = Object.values(this.selectedStatusFilters).indexOf(true) > -1;
    let checkboxFiltersActive = Object.values(this.selectedCheckboxFilters).indexOf(true) > -1;

    if (localStorage.getItem('requests-page-selected-tab') == 'backGroundCheck' && this.localStorageName == 'requests-filter') {
      this.setFilterCount(checkboxFiltersActive, statusFiltersActive, this.filter !== 'All');
    } else {
      if (this.localStorageName == 'people-filters' && this.selectedTab == 'talent_pool') {
        const isLocation = this.textValueLocation !== '' && this.textValueLocation !== undefined;
        const defaultStatusFilters = !this.selectedStatusFilters['Target'] &&
          !this.selectedStatusFilters['Potential target'] &&
          !this.selectedStatusFilters['No target'] &&
          !this.selectedStatusFilters['Unknown'];
        const defaultOptedInFilters = !this.selectedOptedInFilters['Candidate'] && !this.selectedOptedInFilters['Potential candidate'] &&
          !this.selectedOptedInFilters['Ex-employee'];
        this.setFilterCount(isLocation, !defaultStatusFilters, this.filter != $localize`Last 30 days`, !defaultOptedInFilters);
      } else {
        this.setFilterCount(statusFiltersActive, checkboxFiltersActive, this.filter !== 'All', this.isDepartmentFilterOn);
      }
    }
  }
  onSelectCheckbox(status, event) {
    this.selectedCheckboxFilters[status] = event.target.checked;
  }

  onSelectStatus(status) {
    if (this.selectedStatusFilters[status]) {
      this.selectedStatusFilters[status] = false;
    } else {
      this.selectedStatusFilters[status] = true;
    }
  }

  reset(check?: any) {
    this.selectedCheckboxFilters = {};
    this.selectedStatusFilters = {};
    if (this.selectedTab == 'talent_pool')
    {
      this.showDatesRow = false;
      this.textValueLocation = '';
      this.selectedDistance = this.distanceDropdownOptions[0].value;
      this.selectedDate = this.dateDropdownOptions[5].value;
      this.start = moment().subtract(30, 'days').startOf('day');
      this.end = moment().endOf('day');
      this.filter = this.dateDropdownOptions[5]?.value || $localize`Last 30 days`;

      this.selectedStatusFilters = {
        'Target': true,
        'Potential target': true
      };
      this.selectedOptedInFilters = {
        'Candidate': false,
        'Potential candidate': false,
        'Ex-employee': false
      }
      const current = this.getCurrentFilterSnapshot();
      this.filtersHaveBeenModified = !this.isFilterSnapshotEqual(current, this.defaultFiltersSnapshot);
    }
    this.filterEnabled = false;
    localStorage.removeItem(this.localStorageName);
    if(!check) localStorage.removeItem(`${this.selectedTab}_filters`);
  }

  isFilterSnapshotEqual(current: any, snapshot: any): boolean {
    const getTrueKeys = (obj) => Object.keys(obj || {}).filter(k => obj[k]);

    const areArraysEqual = (a: string[], b: string[]) =>
      a.length === b.length && a.every(val => b.includes(val));

    const normalizeText = (val: any) => (val || '').trim();

    return (
      areArraysEqual(getTrueKeys(current.selectedStatusFilters), getTrueKeys(snapshot.selectedStatusFilters)) &&
      areArraysEqual(getTrueKeys(current.selectedOptedInFilters), getTrueKeys(snapshot.selectedOptedInFilters)) &&
      normalizeText(current.textValueLocation) === normalizeText(snapshot.textValueLocation) &&
      current.selectedDistance === snapshot.selectedDistance &&
      current.selectedDate === snapshot.selectedDate
    );
  }

  private setLabel() {
    this.startStr = this.start.format('L');
    this.endStr = this.end.format('L');
  }

  setFilterCount(checkboxActive, statusActive, dateFilter, departmentFilterSet = false, isDefaultfilterByVar=true) {
    this.filterCount = 0;
    if (this.isCheckboxFilters && checkboxActive) {
      this.filterCount  += 1;
    }
    if (this.isStatusFilters && statusActive) {
      this.filterCount  += 1;
    }
    if (dateFilter) {
      this.filterCount += 1;
    }
    if (departmentFilterSet) {
      this.filterCount += 1;
    }
    if (!isDefaultfilterByVar) this.filterCount += 1;

  }

  update(event) {
    if (this.selectedTab === 'talent_pool')  {
     this.saveTalentPoolFilters();
    }
    let statusFiltersActive = Object.values(this.selectedStatusFilters).indexOf(true) > -1;
    let checkboxFiltersActive = Object.values(this.selectedCheckboxFilters).indexOf(true) > -1;
    const isDefaultfilterByVar = this.isFilterByVarDefault(event['filterByVar']);
    if (this.isCheckboxFilters && !checkboxFiltersActive &&
      this.isStatusFilters && !statusFiltersActive &&
        event['filter'] === 'All' && isDefaultfilterByVar
    ) {
      this.filterEnabled = false;
      localStorage.removeItem(this.localStorageName);
    } else if (!this.isCheckboxFilters && !this.isStatusFilters && event['filter'] === 'All' && isDefaultfilterByVar) {
      this.filterEnabled = false;
    }
    else if (!this.isCheckboxFilters && !checkboxFiltersActive &&
      this.isStatusFilters && !statusFiltersActive &&
        event['filter'] === 'All' && isDefaultfilterByVar
    ){
      this.filterEnabled = false;
      localStorage.removeItem(this.localStorageName);
    }
    else {
      this.filterEnabled = true;
      localStorage.removeItem(this.localStorageName);
    }
    let departmentFilterSet = false;
    let output = {};
    if (this.selectedTab != 'talent_pool') {
      this.start = event['start'];
      this.end = event['end'];
      this.filterBy = event['filterBy'];
      this.filterByVar = event["filterByVar"]
      this.filter = event['filter'];

      departmentFilterSet = (event['department_id'] != undefined && event['department_id'] !== 'all') || (event['department_category_id'] != undefined && event['department_category_id'] !== 'all');
      this.isDepartmentFilterOn = departmentFilterSet;

      output = {
        'start_date': this.start,
        'end_date': this.end,
        'filter': this.filter,
        'filterBy': this.filterBy,
        'department_id': event['department_id'],
        'department_category_id': event['department_category_id'],
        'filterByVar': this.filterByVar
      };

      if (this.isRadioFilters) {
        output['radioOption'] = this.radioFilter;
      }
      if (this.isCheckboxFilters && checkboxFiltersActive) {
        output['checkboxOption'] = Object.keys(this.selectedCheckboxFilters).filter(filter => this.selectedCheckboxFilters[filter]);
      } else {
        output['checkboxOption'] = ['all']
      }
    }
    if (this.isStatusFilters) {
      output['statusOption'] = Object.keys(this.selectedStatusFilters).filter(filter=>this.selectedStatusFilters[filter]);
    }
    if (this.selectedTab == 'talent_pool') {
      output = {
        ...output,
        start_date: this.start ? this.start: moment().startOf('day').subtract(30, 'days'),
        end_date: this.end ? this.end: moment(),
      };
      if (this.textValueLocation) {
        output['location'] = this.textValueLocation;
        if (this.selectedDistance) {
          output['distance'] = this.getUntranslatedDistanceKey(this.selectedDistance);
        }
      }
      if (this.selectedDate) {
        output['filter'] = this.selectedDate;
      }
      output['optInOption'] = Object.keys(this.selectedOptedInFilters).filter(filter=>this.selectedOptedInFilters[filter]);
      this.filtersHaveBeenModified = false;
      this.defaultFiltersSnapshot = this.getCurrentFilterSnapshot();
    }

    this.setLabel();

    if (this.filterEnabled) {
      localStorage.setItem(this.localStorageName, JSON.stringify(output));
    }
    if (localStorage.getItem('requests-page-selected-tab') == 'backGroundCheck') {
      this.setFilterCount(checkboxFiltersActive, statusFiltersActive, event['filter'] !== 'All', departmentFilterSet, isDefaultfilterByVar);
    } else {
      this.setFilterCount(statusFiltersActive, checkboxFiltersActive, event['filter'] !== 'All', departmentFilterSet, isDefaultfilterByVar);
    }

    this.filterUpdate.emit(output);
    this.filterDropdown.hide();
  }

  assignPulseFont(label) {
    if(label==='Insights available') {
      return 'pulse-font'
    }
    else {
      return ''
    }
  }

  isInSelectedStatusFilters(status){
    return !!this.selectedStatusFilters[status];
  }

  isFilterByVarDefault(filterByVar: string): boolean {
    if (this.peopleTab) {
        return filterByVar === "Last activity";
    } else {
        return ["Send date", "Cutoff date"].includes(filterByVar);
    }
  }

  updateDistance(event) {
    this.selectedDistance = event.value;
    const current = this.getCurrentFilterSnapshot();
    this.filtersHaveBeenModified = !this.isFilterSnapshotEqual(current, this.defaultFiltersSnapshot);
  }

  optInDateDropdownChange(event: any) {
    const value = event.value;
    this.selectedDate = value;
    this.filter = value;

    if (value === $localize`Custom`) {
      this.showDatesRow = true;
    } else {
      this.showDatesRow = false;
    }

    if (value === $localize`All`) {
      this.start = moment('1970-01-01T00:00:00.000');
      this.end = moment();
    }

    // Match days filters
    const daysMap = {
      [$localize`Last 7 days`]: 7,
      [$localize`Last 30 days`]: 30,
      [$localize`Last 60 days`]: 60,
      [$localize`Last 90 days`]: 90,
      [$localize`Last 365 days`]: 365
    };

    if (value in daysMap) {
      this.calculateLastDays(daysMap[value]);
    }

    // Match calendar-based filters
    const calendarFilters = [
      { label: $localize`Current week`, key: 'currentWeek' },
      { label: $localize`Last week`, key: 'lastWeek' },
      { label: $localize`Current month`, key: 'currentMonth' },
      { label: $localize`Last month`, key: 'lastMonth' },
      { label: $localize`Current quarter`, key: 'currentQuarter' },
      { label: $localize`Last quarter`, key: 'lastQuarter' },
      { label: $localize`Current year`, key: 'currentYear' },
      { label: $localize`Last year`, key: 'lastYear' },
    ];

    const selectedFilter = calendarFilters.find(f => f.label === value);
    if (selectedFilter) {
      this.calculateCalendarDates(selectedFilter.key);
    }

    const current = this.getCurrentFilterSnapshot();
    this.filtersHaveBeenModified = !this.isFilterSnapshotEqual(current, this.defaultFiltersSnapshot);
  }

  calculateLastDays(days: number) {
    this.showDatesRow = false;
    this.start = moment().startOf('day').subtract(days, 'days');
    this.end = moment();
  }

  calculateCalendarDates(filter: string) {
    this.showDatesRow = false;
    switch (filter) {
      case 'currentWeek':
        this.start = moment().startOf('week');
        this.end = moment().endOf('week');
        break;
      case 'lastWeek':
        this.start = moment().subtract(1, 'weeks').startOf('week');
        this.end = moment().subtract(1, 'weeks').endOf('week');
        break;
      case 'currentMonth':
        this.start = moment().startOf('month');
        this.end = moment().endOf('month');
        break;
      case 'lastMonth':
        this.start = moment().subtract(1, 'months').startOf('month');
        this.end = moment().subtract(1, 'months').endOf('month');
        break;
      case 'currentQuarter':
        this.start = moment().startOf('quarter');
        this.end = moment().endOf('quarter');
        break;
      case 'lastQuarter':
        this.start = moment().subtract(1, 'quarters').startOf('quarter');
        this.end = moment().subtract(1, 'quarters').endOf('quarter');
        break;
      case 'currentYear':
        this.start = moment().startOf('year');
        this.end = moment().endOf('year');
        break;
      case 'lastYear':
        this.start = moment().subtract(1, 'years').startOf('year');
        this.end = moment().subtract(1, 'years').endOf('year');
        break;
    }
  }

  onDateChange(dates: { start: moment.Moment, end: moment.Moment }) {
    this.start = dates.start;
    this.end = dates.end;
    this.setLabel();
  }

  cancel() {
    this.filterDropdown.hide();
  }

  disableApply() {
    if (this.isDatePickerVisible()) {
      return true;
    }
    return this.areFiltersDefault() && !this.filtersHaveBeenModified;
  }

  isDatePickerVisible(): boolean {
    return this.showStartCalendar || this.showEndCalendar;
  }

  private areFiltersDefault() {
    const isLocationEmpty = !this.textValueLocation;
    const isDatesRowDisabled = !this.showDatesRow;
    const isStatusFiltersDefault = this.selectedStatusFilters['Target'] &&
      this.selectedStatusFilters['Potential target'] &&
      !this.selectedStatusFilters['No target'] &&
      !this.selectedStatusFilters['Unknown'];
    const isOptedInFiltersDefault = !this.selectedOptedInFilters['Candidate'] &&
      !this.selectedOptedInFilters['Potential candidate'] &&
      !this.selectedOptedInFilters['Ex-employee'];

    const isOptInDateDefault = this.selectedDate === this.dateDropdownOptions[5].value;

    // Only validate distance if location is filled
    const isDistanceDefault = isLocationEmpty || (this.distanceDropdownOptions[0].value === this.selectedDistance);

    return isLocationEmpty && isStatusFiltersDefault && isDatesRowDisabled && isOptedInFiltersDefault && isDistanceDefault && isOptInDateDefault;
  }

  onCalendarVisibilityChange(event: { showStart: boolean; showEnd: boolean }) {
    this.showStartCalendar = event.showStart;
    this.showEndCalendar = event.showEnd;
  }

  getUntranslatedDistanceKey(selectedValue: string): string | null {
    if (!selectedValue) return null;

    const [distanceStr, unit] = selectedValue.trim().split(' ');
    const distance = Number(distanceStr);

    if (isNaN(distance)) return null;

    const unitMap: Record<string, string> = {
      [$localize`:@@miles:mi`]: 'mi',
      [$localize`:@@kilometers:km`]: 'km'
    };

    return unitMap[unit] ? `${distance} ${unitMap[unit]}` : null;
  }

  isInSelectedFilter(key: string, value: string): boolean {
    if (key === 'status') {
      return !!this.selectedStatusFilters[value];
    } else {
      return !!this.selectedOptedInFilters[value];
    }
  }

  getCurrentFilterSnapshot(): any {
    return {
      selectedStatusFilters: {...this.selectedStatusFilters},
      selectedOptedInFilters: {...this.selectedOptedInFilters},
      textValueLocation: this.textValueLocation,
      selectedDistance: this.selectedDistance,
      selectedDate: this.selectedDate
    };
  }

  onSelectFilter(key: string, value: string): void {
    if (key === 'status') {
      this.selectedStatusFilters[value] = !this.selectedStatusFilters[value];
    } else {
      this.selectedOptedInFilters[value] = !this.selectedOptedInFilters[value];
    }
    const current = this.getCurrentFilterSnapshot();
    this.filtersHaveBeenModified = !this.isFilterSnapshotEqual(current, this.defaultFiltersSnapshot);
  }

  onLocationChange(newLocation: any) {
    this.textValueLocation = newLocation;
    const current = this.getCurrentFilterSnapshot();
    this.filtersHaveBeenModified = !this.isFilterSnapshotEqual(current, this.defaultFiltersSnapshot);
  }
}
